import React from 'react';
import qr from "../Images/qr-code.png"

interface PhoneWithPassProps{
    stripBackgroundUrl :string | null,
    stripBackgroundColor :string,
    backgroundColor: string,
    pointImageUrl : string,
    pointsToCollect : number,
    points : number,
    logoUrl : string 
    textColor :string
    radeemedRewards:number 
}

const PhoneWithPass: React.FC<PhoneWithPassProps> = (props) => {

    function getImagePath(url:string){
        const parsedUrl = new URL(url);

        // Get the pathname (which includes the folder and file name)
        const pathname = parsedUrl.pathname;

        // Extract the folder and file name
        const parts = pathname.split('/');
        const folderName = parts[parts.length - 2];  // "logos"
        const fileName = parts[parts.length - 1];   // "566d8092-af5c-487b-acef-d36bff6bdd1f.png"
        
        return `${process.env.REACT_APP_HOST}Images/${folderName}/${fileName}`;
    }

    const points = [];
        const temp = props.pointsToCollect;
        const pointImagePath = getImagePath(props.pointImageUrl);

        // Calculate the number of points per row dynamically
        const num = temp > 5 ? temp / (temp * 0.15) : temp;

        for (let i = 0; i < temp; i++) { // Loop from 0 to temp - 1
        points.push(
            <img
            key={i}
            style={{
                width: "auto",
                height: "auto",
                maxWidth: temp < 4
                ? `calc(100% / ${num} - 3px)`
                : `calc(100% / ${num} - ${temp / 2}px)`, // Calculate based on `num` and `temp`
                margin: "1px",
                boxSizing: "border-box",
                opacity: i < props.points % props.pointsToCollect ? 1 : 0.4, // Adjust opacity
            }}
            src={pointImagePath}
            alt={`Point ${i + 1}`}
            />
        );
        }

    // console.log("number of points:"+points.length)
  return (
    <div
    className="flex flex-row content-center items-start w-[220px] h-[455px] sm:w-[180px] sm:h-[370px] bg-cover bg-top"
    style={{ backgroundImage: `url(/iphone.png)` }}
    >

        <div style={{backgroundColor:props.backgroundColor}} className={`flex w-[100%] h-[65%] rounded flex-col  m-4 sm:m-4 sm:mt-8  mt-12`}>
            <div className='flex rtl:justify-end ltr:justify-start'>
                <img className=' w-[70%] p-1 ' src={getImagePath(props.logoUrl)} alt="logo" />
            </div>
            <div
                style={
                    props.stripBackgroundUrl
                    ? {
                        backgroundColor: props.stripBackgroundColor || "#374151",
                        backgroundImage: `url(${getImagePath(props.stripBackgroundUrl)})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        }
                    : { backgroundColor: props.stripBackgroundColor || "#374151" }
                }
                className="flex flex-row w-full h-[25%] min-h-[50px] shrink-0 mt-2 flex-wrap content-center justify-center items-center"
                >
              {points}
            </div>
            <div className="flex flex-row justify-between">
                <div>
                    <p style={{fontSize:"6px", color:props.textColor}} className='p-1 pb-0' >النقاط المتبقية للهدية</p>
                    <p style={{fontSize:"6px", color:props.textColor}} className='p-1 pt-0' >{props.pointsToCollect - (props.points%props.pointsToCollect)}</p>
                </div>
                
                <div>
                    <p style={{fontSize:"6px", color:props.textColor}} className='p-1 pb-0' >الهدايا</p>
                    <p style={{fontSize:"6px", color:props.textColor}} className='p-1 pt-0' >{Math.floor((props.points/props.pointsToCollect) - props.radeemedRewards)}</p>
                </div>
            </div>
            <div className=' mt-auto flex flex-row justify-center mb-2 '>
                <img src={qr} className='w-[45%]' alt="" />
            </div>
       
        </div>

  </div>
  );
};

export default PhoneWithPass;